<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        append-icon="mdi-calendar"
        :readonly="readonly"
        v-maska:[options]
        v-model="formattedDate"
        @click:clear="clear"
        v-bind="$attrs"
        @click:append="showPicker = true"
        :error-messages="validateDate"
        :placeholder="format"
        @blur="textChange"
      ></v-text-field>
    </template>
    <v-date-picker
      :disabled="readonly"
      v-model="dateValue"
      @change="change"
      @input="showPicker = false"
      :locale="userCultureCode"
      :first-day-of-week="1"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import Utils from '@/ecm/common/Utils';
export default {
    props: {
        value: {
            type: String
        },
        readonly: {
            type: Boolean,
            default: false
        },
        errorMessages: {
            type: Array,
            default: () => []
        }
    },
    created() {
        if (this.value) {
            this.dateValue = Utils.date.changeFormat(
                this.value,
                this.$store.getters['account/user'].MetricDateFormat,
                'YYYY-MM-DD'
            );
            this.formattedDate = this.value;
        }
    },
    data() {
        return {
            showPicker: false,
            userCultureCode: this.$store.getters['account/user'].CultureCode,
            formattedDate: '',
            dateValue: null,
            format: '',
            options: {
                mask: ''
            }
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        validateDate() {
            const errors = [];
            const format = this.$store.getters['account/user'].MetricDateFormat;
            if (this.formattedDate && !Utils.date.IsValidDate(this.formattedDate, format)) {
                errors.push(this.$t('InvalidDate'));
            }
            if (this.errorMessages && errors.length === 0) {
                errors.push(...this.errorMessages);
            }
            return errors;
        }
    },
    mounted() {
        this.format = this.userMask();
        this.options.mask = this.userMask();
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.dateValue = Utils.date.changeFormat(
                        newValue,
                        this.$store.getters['account/user'].MetricDateFormat,
                        'YYYY-MM-DD'
                    );
                    this.formattedDate = newValue;
                } else {
                    this.dateValue = null;
                    this.formattedDate = '';
                }
            }
        }
    },
    methods: {
        userMask() {
            return this.$store.getters['account/user'].MetricDateFormat.replaceAll(
                'Y',
                '#'
            )
                .replaceAll('y', '#')
                .replaceAll('M', '#')
                .replaceAll('m', '#')
                .replaceAll('D', '#')
                .replaceAll('d', '#');
        },
        clear() {
            this.dateValue = null;
            this.change();
        },
        change() {
            var value = null;
            if (this.dateValue) {
                value = Utils.date.changeFormat(
                    this.dateValue,
                    'yyyy-MM-dd',
                    this.$store.getters['account/user'].MetricDateFormat
                );
            }
            this.formattedDate = value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        textChange() {
            const format = this.$store.getters['account/user'].MetricDateFormat;
            if (
                this.formattedDate &&
                !Utils.date.IsValidDate(this.formattedDate, format)
            ) {
                this.formattedDate = null;
                this.$emit('input', this.formattedDate);
                this.$emit('change', this.formattedDate);
            } else {
                this.dateValue = Utils.date.changeFormat(
                    this.formattedDate,
                    format,
                    'yyyy-MM-dd'
                );
                this.$emit('input', this.formattedDate);
                this.$emit('change', this.formattedDate);
            }
        }
    }
};
</script>
